import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { selectTags } from 'redux/tags/selectors';
import { selectTag } from 'redux/tags/actions';
import { selectSegmentTypes, selectSegments } from 'redux/segments/selectors';
import ButtonSecond from 'components/common/ButtonSecond';
import IcoPlus from 'images/sources/ic-plus.svg';

import List from './List';
import ListNested from './ListNested';

import { data, nestedData, generateSegments } from './config';

import {
  StyledSidebar,
  ListHeader,
  ButtonContainer,
} from './Sidebar.styles';

class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.onItemClick = this.onItemClick.bind(this);
  }

  onItemClick(tag) {
    this.changeLink(tag);
    this.props.selectTag(tag);
  }

  changeLink(tag) {
    const { history } = this.props;
    const newUrl = this.generateLink(tag);
    history.push(newUrl);
  }

  generateLink(tag) {
    const { is_identified, id, segment } = tag;
    if (is_identified) return `/console/users?is_identified=${is_identified}`;
    else if (segment) return `/console/users?segment_id=${id}`;
    else if (id) return `/console/users?tag_id=${id}`;
    return '/console/users';
  }

  render() {
    const { openSidebar, tags, segmentTypes, segments } = this.props;
    (nestedData.find(item => item.text === 'Iterio') || {}).nestedList = tags;
    const segmentsList = generateSegments(segmentTypes, segments);

    return (
      <StyledSidebar isOpen={openSidebar}>
        <List data={data} onItemClick={this.onItemClick} />

        <br />

        <ListHeader>Tags</ListHeader>

        <ListNested
          data={nestedData}
          onItemClick={this.onItemClick}
        />

        <br />

        <ListHeader>Segments</ListHeader>

        <ListNested
          data={segmentsList}
          onItemClick={this.onItemClick}
        />

        {false && (
          <ButtonContainer>
            <ButtonSecond>
              <img src={IcoPlus} alt="plus" />
              Add group
            </ButtonSecond>
          </ButtonContainer>
        )}

        <br />
      </StyledSidebar>
    );
  }
}

const mapStateToProps = state => ({
  tags: selectTags(state),
  segmentTypes: selectSegmentTypes(state),
  segments: selectSegments(state),
});

export default compose(
  connect(mapStateToProps, { selectTag }),
  withRouter,
)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Sidebar/Sidebar.js